import { memo } from 'react';
import Switch from '@mui/material/Switch';
import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { TextCss } from 'styles';
import type { DialogId, DialogSettingOption } from './dialogSettingsRegistry';
import { BodyCell, BodyRow, ToggleBodyCell } from './DialogSettingsTable.styles';

type DialogSettingsRowProps = {
  option: DialogSettingOption;
  isVisible: boolean;
  onToggleDialogVisibility: (dialogId: DialogId, visible: boolean) => void | Promise<void>;
};

const DialogSettingsRowComponent = ({
  option,
  isVisible,
  onToggleDialogVisibility,
}: DialogSettingsRowProps): React.ReactElement => {
  return (
    <BodyRow data-testid={`dialogs-confirmations-row-${option.id}`} $isVisible={isVisible}>
      <BodyCell>
        <Text css={TextCss.body1}>{option.label}</Text>
      </BodyCell>
      <BodyCell>
        <Text css={TextCss.body1}>{option.location}</Text>
      </BodyCell>
      <BodyCell data-testid={`dialogs-confirmations-status-${option.id}`}>
        <Text css={TextCss.body1}>{isVisible ? 'Visible' : 'Hidden'}</Text>
      </BodyCell>
      <ToggleBodyCell>
        <Stack alignX="end">
          <Switch
            size="small"
            data-testid={`dialogs-confirmations-toggle-${option.id}`}
            slotProps={{
              input: {
                'aria-label': `Toggle visibility for ${option.label}`,
              },
            }}
            checked={isVisible}
            onChange={(_event, checked) => {
              onToggleDialogVisibility(option.id, checked);
            }}
          />
        </Stack>
      </ToggleBodyCell>
    </BodyRow>
  );
};

DialogSettingsRowComponent.displayName = 'DialogSettingsRow';

export const DialogSettingsRow = memo(DialogSettingsRowComponent);
